// Mock data for DC Lock and Key - South Perth

export const businessInfo = {
  name: "Locksmith DC Lock and Key",
  location: "South Perth",
  fullName: "Locksmith DC Lock and Key – South Perth",
  phone: "0406 421 761",
  phoneLink: "tel:0406421761",
  rating: 5.0,
  reviewCount: 41,
  serviceArea: "South Perth & surrounding Perth metro areas",
  image: "https://lh3.googleusercontent.com/p/AF1QipOe0oKjwMzKaHHREL4Jz3YI_qb7RKW4EqErp3FM=w203-h152-k-no",
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13542.550819498677!2d115.85584458328857!3d-31.97628895!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2a32bb0d5c8a5a8d%3A0x504f0b535df5e50!2sSouth%20Perth%20WA%2C%20Australia!5e0!3m2!1sen!2sus!4v1704500000000!5m2!1sen!2sus",
  directionsUrl: "https://www.google.com/maps/place/South+Perth+WA,+Australia"
};

export const openingHours = [
  { day: "Monday", hours: "7 am – 6 pm" },
  { day: "Tuesday", hours: "7 am – 6 pm" },
  { day: "Wednesday", hours: "7 am – 6 pm" },
  { day: "Thursday", hours: "7 am – 6 pm" },
  { day: "Friday", hours: "7 am – 6 pm" },
  { day: "Saturday", hours: "7 am – 1 pm" },
  { day: "Sunday", hours: "7 am – 1 pm" }
];

export const services = [
  {
    id: 1,
    title: "Residential Locksmith",
    description: "Home lock installations, repairs, and upgrades to keep your family safe.",
    icon: "Home"
  },
  {
    id: 2,
    title: "Commercial Locksmith",
    description: "Secure your business with professional lock solutions and access control.",
    icon: "Building2"
  },
  {
    id: 3,
    title: "Lock Repairs & Replacements",
    description: "Expert repair and replacement of all types of locks and hardware.",
    icon: "Wrench"
  },
  {
    id: 4,
    title: "Safe Opening & Servicing",
    description: "Professional safe opening, combination changes, and maintenance.",
    icon: "Lock"
  },
  {
    id: 5,
    title: "Key Cutting & Duplication",
    description: "Precision key cutting and duplication services for all key types.",
    icon: "Key"
  },
  {
    id: 6,
    title: "Security Advice & Upgrades",
    description: "Expert consultation on improving your property's security.",
    icon: "Shield"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Prompt & Reliable",
    description: "We value your time and arrive when we say we will.",
    icon: "Clock"
  },
  {
    id: 2,
    title: "Friendly & Professional",
    description: "Approachable service with expert knowledge.",
    icon: "UserCheck"
  },
  {
    id: 3,
    title: "Fair & Transparent Pricing",
    description: "No hidden fees or surprise charges.",
    icon: "BadgeDollarSign"
  },
  {
    id: 4,
    title: "Quality Workmanship",
    description: "Work done right the first time, every time.",
    icon: "Award"
  },
  {
    id: 5,
    title: "Strong Local Reputation",
    description: "Trusted by South Perth residents and businesses.",
    icon: "Star"
  }
];

export const reviews = [
  {
    id: 1,
    name: "Bob Perovic",
    text: "Dylan is an absolute legend. It is rare to find trades people that respond promptly, are friendly and very reasonably priced. He sorted my safe, a new front door knob and gave me lots of advice on security door, all in a very efficient manner. Highly recommend DC Lock and Key. Keep up the great work!",
    rating: 5
  },
  {
    id: 2,
    name: "Tricia J",
    text: "Super work ethic, kind, friendly, professional and rectified the problematic lock barrel concern very efficiently. Thanks Dillan",
    rating: 5
  },
  {
    id: 3,
    name: "Shelly Grewal",
    text: "Dylan from DC lock and Key was amazing - he went above and beyond to secure our site, cut new keys and give some valuable advice about how to keep our business safe and secure. Really appreciate the service and quality of work completed",
    rating: 5
  }
];
